import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'combos': [],
  'loading': false,
};

export const vehicleCombosByChasis = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_VEHICLE_COMBO_BY_CHASIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_COMBO_BY_CHASIS]: (state, action) => ({
      ...state,
      'loading': false,
      'combos': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLE_COMBO_BY_CHASIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'combos': [],
    }),
    [ActionTypes.CLEAR_VEHICLE_COMBO_BY_CHASIS]: (state, action) => ({
      ...state,
      'loading': false,
      'combos': [],
    }),
  })(state, action);
};
